import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import qs from 'qs';
import { history } from '../../../../utils/navigation-util';
import pathConst from '../../../../constants/PathsConstant';

const CompensationHeader = (props) => {
  const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const { pid, hasNonExecutivesData = true } = props;
  const isNonUsCompensationSource = useSelector((state) => state.company?.isUsCompensationSource === false);
  if (pid !== undefined) {
    query.pid = pid;
  }

  const navItems =
    window.location.host === 'one.insightia.com'
      ? [
          {
            to: pathConst.COMPANY_COMPENSATION_OVERVIEW,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Overview',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.COMPANY_COMPENSATION_ANALYSIS_DASHBOARD,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Compensation Analysis',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.COMPANY_COMPENSATION_PERFORMANCE_INDICATORS,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Performance Indicators',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.NON_EXECUTIVES_FEE_POLICY,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Non-Executives Fee Policy',
            exact: true,
            disabled: !hasNonExecutivesData,
          },
          {
            to: pathConst.COMPANY_COMPENSATION_REMUNERATION_POLICY,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Remuneration Policy',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.COMPANY_PAY_FOR_PERFORMANCE,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Pay for Performance',
            exact: true,
            disabled: false,
          },
        ]
      : [
          {
            to: pathConst.COMPANY_COMPENSATION_OVERVIEW,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Overview',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.COMPANY_COMPENSATION_ANALYSIS_DASHBOARD,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Compensation Analysis',
            exact: true,
            disabled: false,
            hidden: isNonUsCompensationSource,
          },
          {
            to: pathConst.COMPANY_COMPENSATION_PERFORMANCE_INDICATORS,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Performance Indicators',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.NON_EXECUTIVES_FEE_POLICY,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Non-Executives Fee Policy',
            exact: true,
            disabled: !hasNonExecutivesData,
          },
          {
            to: pathConst.COMPANY_COMPENSATION_REMUNERATION_POLICY,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Remuneration Policy',
            exact: true,
            disabled: false,
          },
          {
            to: pathConst.COMPANY_PAY_FOR_PERFORMANCE,
            search: `${pathConst.QUERY_PID}${query.pid}`,
            name: 'Pay for Performance',
            exact: true,
            disabled: false,
          },
        ];

  return (
    <nav className="subnavbar navbar navbar-expand-md navbar-light bg-light">
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto">
          {navItems
            .filter(({ hidden }) => !hidden)
            .map(({ to, name, exact, search, disabled }, index) => (
              <li
                className="nav-item"
                key={`nav-item_${index + 1}`}
                onMouseEnter={() => props.handleHoverSubmenu(to.substr(0, to.lastIndexOf('/')))}
                onMouseLeave={() => props.handleHoverSubmenu('')}
              >
                <NavLink
                  to={to + search}
                  onClick={(e) => {
                    e.preventDefault();
                    history.push({
                      pathname: to,
                      search,
                      state: {},
                    });
                    props.handleResetBreadcrumbs(to);
                    props.handleResetCompanyPath(to);
                    props.handleVisitorLog(to, search);
                  }}
                  className={disabled ? 'nav-link disabled' : 'nav-link'}
                  activeClassName={disabled ? '' : 'active'}
                  id={`navItem-${name}-${index}`}
                  exact={exact}
                >
                  {name}
                </NavLink>
              </li>
            ))}
        </ul>
      </div>
    </nav>
  );
};

export default withRouter(React.memo(CompensationHeader));
